const stack = [
  { label: "LANGUAGES", items: ["JavaScript", "TypeScript", "Python", "Dart", "C# / .NET", "PHP", "SQL"] },
  { label: "FRONTEND", items: ["React JS/TS", "Next.js", "Angular", "React Native", "Flutter", "Redux", "Tailwind CSS", "Shadcn", "jQuery", "Electron", "HTML5", "CSS3"] },
  { label: "BACKEND", items: ["Node.js", "Express", "Django", "FastAPI", "Laravel", "CodeIgniter", "ASP.NET", "REST APIs"] },
  { label: "DATA", items: ["PostgreSQL", "MongoDB", "MySQL", "SQLite", "Redis", "Cassandra", "Pinecone", "Milvus"] },
  { label: "DEVOPS & CLOUD", items: ["Docker", "Docker Swarm", "Kubernetes", "Nginx", "Apache", "AWS EC2", "AWS S3", "GitLab CI/CD", "Jenkins", "RabbitMQ", "Git"] },
  { label: "ARCHITECTURE", items: ["Micro-Frontends", "Micro-Services", "Local-First", "Modular Monolith", "RAG / AI", "TDD", "MVVM", "Agile & Scrum"] },
];

export default stack;
